import { HttpClient } from '../http-client';
import { UserGroup } from './types';

export class UserGroupHttpClient extends HttpClient {
  public getUserGroups = async (): Promise<UserGroup[]> => {
    return this.get<UserGroup[]>('/user-groups');
  };
}
